import { jsx as _jsx } from "react/jsx-runtime";
import { TextareaAutosize } from "@air/primitive-textarea";
import { tailwindMerge } from "@air/tailwind-variants";
import { memo, useCallback, useEffect, useState } from "react";
export const CustomFieldPlainTextTableCellInput = /*#__PURE__*/ memo((param)=>{
    let { defaultValue, onSubmit, onBlur, className, fieldName } = param;
    const [value, setValue] = useState(defaultValue);
    useEffect(()=>{
        setValue(defaultValue);
    }, [
        defaultValue
    ]);
    const handleKeyDown = useCallback((event)=>{
        if (event.key === "Enter" && !event.shiftKey) {
            event.stopPropagation();
            event.preventDefault();
            onSubmit(value !== null && value !== void 0 ? value : "");
            onBlur === null || onBlur === void 0 ? void 0 : onBlur();
        }
    }, [
        onBlur,
        onSubmit,
        value
    ]);
    const handleEscOnKeyUp = useCallback((event)=>{
        if (event.key === "Escape") {
            event.stopPropagation();
            setValue(defaultValue);
            onBlur === null || onBlur === void 0 ? void 0 : onBlur();
        }
    }, [
        defaultValue,
        onBlur
    ]);
    const handleFocus = useCallback((event)=>{
        const textareaValue = event.target.value;
        event.target.setSelectionRange(textareaValue.length, textareaValue.length);
    }, []);
    return /*#__PURE__*/ _jsx(TextareaAutosize, {
        "data-testid": "CUSTOM_FIELD_PLAIN_TEXT_TEXTAREA-".concat(fieldName),
        autoFocus: true,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleEscOnKeyUp,
        onBlur: ()=>{
            onSubmit(value !== null && value !== void 0 ? value : "");
            onBlur === null || onBlur === void 0 ? void 0 : onBlur();
        },
        className: tailwindMerge("h-full resize-none py-2 text-14 font-normal text-grey-11 md:text-14", className),
        onChange: (event)=>{
            setValue(event.target.value);
        },
        defaultValue: value,
        placeholder: "None"
    });
});
CustomFieldPlainTextTableCellInput.displayName = "CustomFieldPlainTextTableCellInput";
